module.exports = __webpack_public_path__ + "img/warshaw-incorporated.e370d5b9.png";